import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import classnames from 'classnames/bind';
import { Defaults } from 'app/lib/constants';
import { OpenSnowflakeConnectionStatusButton } from 'app/components/features/SnowflakeConnectionStatus';
import { MappedSnowflakeStatusPropType } from 'app/lib/proptypes';
import * as styles from './SnowflakeDisconnectedOverlay.css';

const cx = classnames.bind(styles);

export const SnowflakeDisconnectedOverlay = ({
    isSnowflakeConnected = false,
    mappedSnowflakeStatus = Defaults.OBJECT
}) => {
    if (isSnowflakeConnected) {
        return null;
    }

    const { isSignInRequired, noStatus } = mappedSnowflakeStatus;

    const bannerClasses = cx('banner', { isError: !isSignInRequired || noStatus });
    const frameClasses = cx('frame', { isError: !isSignInRequired || noStatus });

    const label = noStatus ? 'noStatus' : isSignInRequired ? 'label' : 'unconfiguredLabel';

    return (
        <div className={bannerClasses}>
            <Trans
                i18nKey={`components:SnowflakeDisconnectedOverlay.${label}`}
                components={{
                    linkButton: <OpenSnowflakeConnectionStatusButton />
                }}
            />
            <div className={frameClasses} />
        </div>
    );
};

SnowflakeDisconnectedOverlay.propTypes = {
    isSnowflakeConnected: PropTypes.bool,
    mappedSnowflakeStatus: MappedSnowflakeStatusPropType
};
